import React, {useRef, useState,useEffect,useMemo,useCallback} from "react";
import { Route, Switch, Redirect,useHistory } from "react-router-dom";
// reactstrap components
import {Container} from "reactstrap";

// core components
import AdminFooter from "components/PurchaserFrontend/Footers/AdminFooter.js";
import Sidebar from "components/PurchaserFrontend/Sidebar/Sidebar.js";
import {
	Modal,
   ModalHeader,
   ModalBody,
   ModalFooter,
   Button,
} from "reactstrap";
import routes from "routes.js";
import AuthData from "../lib/Core/AuthData";
import PurchaserAuth from "../lib/Core/Backend/Controllers/PurchaserAuth";
import ReactNotificationAlert from "react-notification-alert";
import Notify from "lib/Utils/Alert";
import Brand from "lib/Core/Backend/Controllers/Brand";
import Catalogs from "lib/Core/Backend/Controllers/Catalogs";
import CatalogsContext from "contexts/catalogsContext";
import AdminNavbar from "components/PurchaserFrontend/Navbars/AdminNavbar";
import ShoppingCartController from "lib/Core/Backend/Controllers/ShoppingCartPurchaseOrder";
import Purchaser from "lib/Core/Backend/Controllers/Purchaser";
import ErrorModal from "components/Core/ErrorModal";
import CardType from "lib/Core/Backend/Controllers/CardType";

const securityGroups = [
	"purchaser"
]

const PurchaserAdmin = (props) =>
{
	const authData = new AuthData(securityGroups);
	const auth = new PurchaserAuth(authData.token);const brandsCtl = React.useMemo(() => new Brand(authData.token), [authData.token])
	const catalogsCtl = React.useMemo(() => new Catalogs(authData.token), [authData.token])
	const purchaserShoppingCart = useMemo(() => new ShoppingCartController(authData.token), [authData.token]);
	
	const history = useHistory();
	const [clickCount, setClickCount] = useState(0)
	const [countries, setCountries] = useState([]);
	const [currencies, setCurrencies] = useState([]);
	const [paymentOptions, setPaymentOptions] = useState([]);
	const [contactTypes, setcontactTypes] = useState([]);
	const [cards, setCards] = useState([]);
	const mainContent = React.useRef(null);
	const [purchaserId, setPurchaserId] = useState(null);
	const [validGroups, setValidGroups] = useState(false);
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [maintainModal,setMainTainModal] = React.useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [data,setData] = useState([]);
	const [storedItems, setStoredItems] = useState(
		JSON.parse(localStorage.getItem("AddItem")) || []
	  );
	const toggleConfirm = () => setMainTainModal(!maintainModal);
    const cardTypeCtl = useMemo(() => new CardType(authData.token),[authData.token]);
	const alert = useRef();
	const [inactive, setInactive] = useState(false);
const inactivityTime = 10 * 60 * 1000; 

const handleLogout = useCallback(() => {
	document.location.href = "/purchaser-auth/login";
	sessionStorage.removeItem('accessToken')
}, []);

const resetTimer = useCallback(() => {
	setInactive(false);
	clearTimeout(window.inactivityTimeout);
	window.inactivityTimeout = setTimeout(() => {
		setInactive(true);
	}, inactivityTime);
}, [inactivityTime]);


useEffect(() => {
    const updateStoredItems = () => {
      const updatedItems = JSON.parse(localStorage.getItem("AddItem")) || [];
      setStoredItems((prev) => {
        if (JSON.stringify(prev) !== JSON.stringify(updatedItems)) {
          return updatedItems;
        }
        return prev;
      });
    };
    window.addEventListener("storage", updateStoredItems);
    const interval = setInterval(() => {
      updateStoredItems();
    }, 1000);
    return () => {
      window.removeEventListener("storage", updateStoredItems);
      clearInterval(interval);
    };
	
  }, []);


useEffect(() => {
	const events = ["mousemove", "keydown", "click"];
	const eventHandler = () => resetTimer();
	
	events.forEach(event => window.addEventListener(event, eventHandler));
	resetTimer();

	return () => {
		events.forEach(event => window.removeEventListener(event, eventHandler));
		clearTimeout(window.inactivityTimeout);
	};
}, [resetTimer]);

useEffect(() => {
	if (inactive) {
		handleLogout();
	}
}, [inactive, handleLogout]);

useEffect(()=>{
	setTimeout(() => {
		setIsLoading(false)
	}, 2500);
},[])
	React.useEffect(() => {
		catalogsCtl.countries(data => {
			if(!(data.error || data.errorMessage)){
				setCountries(data)
			}
		})
		catalogsCtl.paymentOptions(data => {
			if(!(data.error || data.errorMessage)){
				setPaymentOptions(data)
			}
		})
		catalogsCtl.currencies(data => {
			if(!(data.error || data.errorMessage)){
				setCurrencies(data)
			}
		})
		catalogsCtl.contactTypes(data => {
			if(!(data.error || data.errorMessage)){
				setcontactTypes(data)
			}
		})
	},[brandsCtl, catalogsCtl])

	React.useEffect(() =>
	{
		document.documentElement.scrollTop = 0;
		document.scrollingElement.scrollTop = 0;
		if (mainContent.current !== null) mainContent.current.scrollTop = 0;
	}, [mainContent]);

	React.useEffect(() => {
		if (!authData.validateSecurityGroups())
		{
			document.location.href = "/purchaser-auth/login";
			setValidGroups(false);
		} else {
			setValidGroups(true);
			auth.getSourceId((data) => {
				if(data.errorMessage || data.error)
				{
					Notify(alert, 'danger', data.errorMessage ?? data.error)
				} else {
					setPurchaserId(data);
				}
			});
		}
	},[])

	React.useEffect(() => {
		if(authData.token){
			if(purchaserId){
				const purchaserCtl = new Purchaser(authData.token)
				purchaserCtl.activeCards(purchaserId, data => {
					if(data && !data.error){
						setCards(data);
					}
				})
			}
		}
	}, [authData.token, purchaserId])
	

	const hideErrorModal = () => {
		setIsErrorModalOpen(false);
		setErrorMessage('');
	  };
   
	  const handleMaintainModalOff = () =>{
		setMainTainModal(false);
	}
	  const mainatainBackend = () => {
		fetch(`${process.env.REACT_APP_BACKEND_URL}private/auth/maintenance-mode/${true}`)
		
		.then((response) => {
		  
		  toggleConfirm();
		})
		.catch((error) => {
			console.error(`Error: ${error}`);
	})
	
	}
let url;
let maintainCalled = false;
const fetchData = () => {
 url = process.env.REACT_APP_MAINTAIN_URL
    fetch(url)
        .then((response) => {
            if (!response.ok) {
				if(!maintainCalled){
					maintainCalled = true;
					if (response.status === 502 || response.status === 503 || response.status === 504) {
						mainatainBackend();
					}
				}
				
                throw new Error(`HTTP error! Status: ${response.status}`);
				
            }
            return response.json();
        })
        .then((data) => {
			if(data.Status === "OK"){
			}else{
				if (!maintainCalled) { 
					maintainCalled = true;
					mainatainBackend();
				}
			}
            
        })
        .catch((error) => {
            console.error(`Error: ${error}`);
			// if (!maintainCalled) { 
            //     maintainCalled = true; 
            //     mainatainBackend(); 
            // }
        })
       
};
	
	  let pollingInterval;
	
	  useEffect(() => {
		pollingInterval = setInterval(() => {
		  fetchData();
		}, 20000);
	  
		return () => {
		  clearInterval(pollingInterval);
		};
	  }, []);


	  useEffect(() => {
		
		document.title = "ncentiva || Home";
		const currentURL = window.location.href;
	  
		// Get the current path
		const currentPath = window.location.pathname;
		if (!currentURL.includes('localhost') && !['/purchaser-auth/login', '/purchaser-auth/verify-otp','/purchaser-auth/forgot-password','purchaser-auth/send-otp'].includes(currentPath)) {
		
	  
		  // Define _tip array in the global scope
		  var _tip = _tip || [];
	  
		  const script = document.createElement('script');
		  script.type = 'text/javascript';
	  
		  // Define js variable outside the template string
		  var js = document.createElement('script'); // Create the script element here
	  
		  script.innerHTML = `
			(function(d,s,id){
			  var tjs = d.getElementsByTagName(s)[0];
			  if(d.getElementById(id)) { return; }
			  js = d.createElement(s); js.id = id;
			  js.async = true;
			  js.src = d.location.protocol + '//app.truconversion.com/ti-js/33039/a1d99.js';
			  tjs.parentNode.insertBefore(js, tjs);
			  console.log("True Conversion script loaded"); // Debugging log inside script
			}(document, 'script', 'ti-js'));
		  `;
		  document.head.appendChild(script);
	  
		  // Define onExternalScriptLoad function
		  function onExternalScriptLoad() {
			_tip.push(['_trackIdentity', 'dev']);
			
		  }
	  
		  // Wait for the dynamically created script to load
		  js.onload = function() {
			onExternalScriptLoad();
		  };
	  
		} else {
		  
		}
	  }, []);

	  useEffect(()=>{
		purchaserShoppingCart.getCart(
			
			(data) => {
				if (data && !data.error) {
				setData(data?.items)
				}
			})
	},[authData.token, purchaserId,storedItems])


	const getRoutes = (routes, pId) =>
	{
		return routes.map((prop, key) =>
		{
			
			
			if (prop.layout === "/purchaser")
			{
				return (
					<Route
						path={prop.layout + prop.path}
						render={(props) => (<prop.component {...props} token={authData.token} purchaserId={purchaserId}/>)}
						key={key}
					/>
				);
			}
			else
			{
				return null;
			}
		});
	};

	import("assets/plugins/nucleo/css/nucleo.css").then(() => import("assets/scss/argon-dashboard-react.scss"));

	if(!validGroups){
		return null;
	}


	const handleCartClick = () => {
		const newCount = clickCount + 1;
		setClickCount(newCount);
		history.push({
		  pathname: "/purchaser/purchaseorders",
		  state: { fromCart: newCount,showModal:true}, 
		});
	  };

	return (
		<>
   <CatalogsContext.Provider
      value={{
        paymentOptions: paymentOptions,
        countries: countries,
        contactTypes: contactTypes,
        currencies: currencies,
        availableCards: cards,
      }}
    >
      <ReactNotificationAlert ref={alert} />
      {isLoading ? (
		<>
		
		
        <div className='d-flex justify-content-center align-items-center flex-column vh-100'>
		<img src="https://ncentiva-development.s3.eu-west-1.amazonaws.com/ncentiva_new_lowquality_logo.png" style={{height:"26px",width:"140px"}} alt="" />
		<div className="spinner-border text-muted text-center mt-2"></div>
	 </div>
	 </>
      ) : (
        <>
          <Sidebar
            {...props}
            routes={routes}
            logo={{
              innerLink: "/purchaser/dashboard",
              imgSrc: require("../assets/img/brand/argon-react.png").default,
              imgAlt: "...",
            }}
          />
          <div
            className="main-content d-flex justify-content-between flex-column"
            style={{ height: "100vh", backgroundColor: "#E8EDFB" }}
            ref={mainContent}
          >
            <div>
              <div className="bg-white shadow-sm text-end px-4 py-3 sticky-top mb_disc">
                <AdminNavbar data={data} onCartClick={handleCartClick} />
              </div>

              <Switch>
                {getRoutes(routes, purchaserId)}
                <Redirect from="*" to="/admin/index" />
              </Switch>
            </div>

            <Container fluid style={{ backgroundColor: "#E8EDFB" }}>
              <AdminFooter token={authData.token} />
            </Container>
          </div>
        </>
      )}
    </CatalogsContext.Provider>
			<Modal isOpen={maintainModal} toggle={toggleConfirm} centered={true} backdrop="static">
                    <ModalHeader className="custom_header_colour align-items-center" toggle={toggleConfirm}>
                        <h3 className='mb-0 ' style={{ fontSize: '20px' }}>Server Alert</h3>
                    </ModalHeader>
                    <ModalBody>
                        <p className="card-just-text"  style ={{fontSize:"20px"}}>
                           The Server is on Maintaince 
                        </p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={handleMaintainModalOff}>Cancel</Button>{' '}
                        
                    </ModalFooter>
                </Modal>
				
		</>
	);
};

export default PurchaserAdmin;
